/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description modals reducers
 */

import { payloadReducer } from '@zcode/reducers'
import type { Modals } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { CLOSE_MODAL, OPEN_MODAL } from '../constants/index'
import type { ActionTypes } from '../types'
import { flagReducer } from './flagModal'
import { hashtagReducer } from './hashtagModal'
import { inactiveSaveSearchReducer } from './inactiveSaveSearchModal'
import { messageReducer } from './messageModal/index'
import { metroRentReportReducer } from './metroRentReportModal'
import { multiMessageReducer } from './multiMessageModal'
import { saveSearchReducer } from './saveSearchModal'
import { savedSearchOptionReducer } from './savedSearchOptionModal'

export const modalsReducer = combineReducers<Modals, ActionTypes>({
  open: handleActions<Modals['open'], ActionTypes>(
    {
      [OPEN_MODAL]: payloadReducer,
      [CLOSE_MODAL]: () => null,
    },
    null
  ),
  flag: flagReducer,
  hashtag: hashtagReducer,
  inactiveSaveSearch: inactiveSaveSearchReducer,
  message: messageReducer,
  metroRentReport: metroRentReportReducer,
  multiMessage: multiMessageReducer,
  savedSearchOption: savedSearchOptionReducer,
  saveSearch: saveSearchReducer,
})
